module.exports = __webpack_public_path__ + "media/assets/images/btn_create_work-8cacbedcabfff8c3df520fac21e69f5f.png";